/**
 * KpiSection — KPI cards row + ticket-type breakdown chips.
 * Rendered when showKpis is true.
 *
 * Props: data, showKpis, typeBreakdown
 */
import React from 'react';
import { fmt$, fmtN, pct } from '../../../utils/formatUtils';
import { TICKET_TYPE_META } from '../squareDashboardUtils';
import KPI from './KPI';

export default function KpiSection({ data, showKpis, typeBreakdown }) {
  if (!showKpis) return null;

  const totalRevCents     = parseFloat(data.summary.totalRevenue)      * 100;
  const totalDiscCents    = parseFloat(data.summary.totalDiscount)     * 100;
  const totalReturnCents  = parseFloat(data.summary.totalReturnRevenue)* 100;
  const netSalesCents     = totalRevCents - totalDiscCents - totalReturnCents;

  return (
    <>
      <div className="sq__kpis">
        <KPI
          icon="&#x1F4CA;" accent="teal" label="Net Sales"
          value={fmt$(netSalesCents / 100)}
          sub={`Revenue \u2212 Discounts \u2212 Returns`}
        />
        <KPI
          icon="&#x1F3AB;" accent="indigo" label="Total Tickets"
          value={fmtN(data.summary.totalTickets)}
          sub={`${fmtN(data.summary.openTickets)} open \u00B7 ${fmtN(data.summary.completedTickets)} done`}
        />
        <KPI
          icon="&#x1F4B5;" accent="green" label="Revenue"
          value={fmt$(data.summary.totalRevenue)}
          sub="After discounts, before tax"
        />
        <KPI
          icon="&#x1F6D2;" accent="blue" label="Total Items Sold"
          value={fmtN(data.categories.reduce((s, c) => s + c.itemQty, 0))}
          sub={`across ${data.categories.length} categories`}
        />
        <KPI
          icon="&#x1F3F7;&#xFE0F;" accent="amber" label="Discounts"
          value={fmt$(data.summary.totalDiscount)}
          sub={pct(parseFloat(data.summary.totalDiscount), parseFloat(data.summary.totalRevenue)) + ' of revenue'}
        />
        <KPI
          icon="&#x21A9;&#xFE0F;" accent="rose" label="Returns"
          value={fmtN(data.summary.totalReturnQty)}
          sub={fmt$(data.summary.totalReturnRevenue) + ' value returned'}
          alert={data.summary.totalReturnQty > 0}
        />
      </div>

      <div className="sq__type-chips">
        {Object.entries(TICKET_TYPE_META).map(([k, v]) => {
          const stats = typeBreakdown[k] || { count: 0, revenueCents: 0, discountCents: 0 };
          if (stats.count === 0) return null;
          const revPct = totalRevCents > 0
            ? ((stats.revenueCents / totalRevCents) * 100).toFixed(1) + '%'
            : '';
          return (
            <div key={k} className={`sq__type-chip sq__type-chip--${k}`}>
              <span className="sq__type-chip-label">{v.label}</span>
              <span className="sq__type-chip-sep">&middot;</span>
              <span className="sq__type-chip-count">{fmtN(stats.count)}</span>
              <span className="sq__type-chip-sep">&middot;</span>
              <span className="sq__type-chip-rev">{fmt$(stats.revenueCents / 100)}</span>
              {revPct && (
                <>
                  <span className="sq__type-chip-sep">&middot;</span>
                  <span className="sq__type-chip-pct">{revPct}</span>
                </>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}
